<mat-nav-list [disableRipple]="true">

  @for (item of menu; track $index) {
    <ng-container>
      <!-- bypassAccessProfile: item só por papel (liberação de títulos vencidos, D16). Substitui as regras de perfil,
           porque um item sem profileModule passa em canAccess para qualquer perfil -->
      @if ((!item.inDevelopment || !isProduction) &&
            (!item.hideInProduction || !isProduction || isTecincoMember) &&
            (
            item.bypassAccessProfile
            ?
            !item.blockedRoles?.includes(userRole)
            :
            (
            (
              !item.blockedRoles?.includes(userRole)
              &&
              !(accessProfile)
            )
            ||
            (
              (accessProfile)
              &&
              ((accessProfile) | canAccess: item.profileModule : true)
            )
            )
            )) {
        <a mat-list-item
            class="menu-item"
            (click)="navigateOrExpand(item, true); resetCache(item.component)"
            [title]="layout.menu.sideNavExpanded ? '' : (('MENU.' + item?.component) | translate)"
            [class.selected]="(layout.component | menuSelected : item : layout.menu[item.component] : true )">
            @if (item.icon) {
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            } @else if (item.svgIcon) {
              <mat-icon matListItemIcon
                        style="display: block;"
                        [svgIcon]="item.svgIcon"></mat-icon>
            }
  
            @if (layout.menu.sideNavExpanded) {
              <h3 matListItemTitle>{{ ('MENU.' + item.component) | translate }}</h3>
            }
  
            @if (item.childs && layout.menu.sideNavExpanded) {
              <button mat-icon-button matListItemMeta>
                @if(layout.menu.elementExpandend?.component === item.component){
                <mat-icon>expand_more</mat-icon>  
                } @else {
                  <mat-icon>expand_less</mat-icon>
                }
              </button>
            }  
        </a>
      }

      @if ((
            (
              !item.blockedRoles?.includes(userRole)
              &&
              !(accessProfile)
            )
            ||
            (
              (accessProfile)
              &&
              ((accessProfile) | canAccess: item.profileModule : true)
            )
          )
          && (layout.menu.elementExpandend?.component === item.component)
          && item.childs
          && (!item.inDevelopment || !isProduction)
          && (!item.hideInProduction || !isProduction || isTecincoMember)
        ) {
        <ng-container>
          @for (child of item.childs; track $index) {
            <ng-container>
              @if((!child.hideInProduction || !isProduction || isTecincoMember)
                && (
                  (
                    (accessProfile)
                    &&
                    (accessProfile | canAccess: child.profileRule)
                  )
                  || (
                    !child.blockedRoles?.includes(userRole)
                    &&
                    !(accessProfile)
                    &&
                    (!child.inDevelopment || !isProduction)
                  )
                )
              ) {
                <a mat-list-item
                  [routerLink]="child.href"
                  [queryParams]="child.queryParams"
                  class="sub-item"
                  [class.selected]="(layout.component === child.component || child.shadows?.includes(layout.component))">
                    <h3 matListItemTitle> {{ ('MENU.' + child.component) | translate }} </h3>
                </a>
              }
            </ng-container>
          }
        </ng-container>
      }
    </ng-container>
  }
</mat-nav-list>
